export enum Workflow_Status {
  pendingActivation = "PENDING_ACTIVATION",
  pendingOrganization = "PENDING_ORGANIZATION",
  pendingSubscription = "PENDING_SUBSCRIPTION",
  subscribed = "SUBSCRIBED",
  subscribedPassive = "SUBSCRIBED_PASSIVE",
  subscribedActive = "SUBSCRIBED_ACTIVE"
}

export enum LeadFormType {
  requestDemo = "REQUEST_DEMO",
  contactUs = "CONTACT_US",
}

export enum InquiryType {
  demo = 'DEMO',
  contact = 'CONTACT',
}
export enum EVENT_MEDIUM {
  IN_APP = 'IN_APP',
  WHATSAPP = 'WHATSAPP',
  EMAIL = 'EMAIL',
  SMS = 'SMS',
}

export enum EVENT_TRIGGER_TYPE {
  IMMEDIATE = 'IMMEDIATE',
  WITH_DELAY = 'WITH_DELAY',
};
export enum USER_ROLE {
  ORG_ADMIN = 'ORG_ADMIN',
  ORG_OWNER = 'ORG_OWNER',
  ORG_APP_USER = 'ORG_APP_USER',
  ORG_SURVEY_USER = 'ORG_SURVEY_USER',
  
}
export enum QUESTIONNAIRE_TYPE {
  NPS = 'NPS',
  FEEDBACK = 'FEEDBACK',
  SURVEY = 'SURVEY',
  AI = 'AI',
}
export enum QUESTIONNAIRE_SUB_TYPE {
  EVENT_BASED = 'EVENT_BASED',
  NPS = 'NPS',
  GENERAL_FEEDBACK = 'GENERAL_FEEDBACK',
  QR_BASED = 'QR_BASED',
  PERIODIC_BASED = 'PERIODIC_BASED',
  SURVEY = 'SURVEY',

}
export enum USER_INFO_CAPTURE_STATUS {
  ANANYMOUS = 'ANANYMOUS',
  OPTIONAL = 'OPTIONAL',
  MANDATORY = 'MANDATORY',
}

export enum QUESTIONNAIRE_STATUS {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  ARCHIVED = 'ARCHIVED',
  PASSIVE = 'PASSIVE',
  DELETED = 'DELETED',
  EXPIRED = 'EXPIRED',
  SCHEDULED = 'SCHEDULED',
  CLOSED="CLOSED"
}